'use client'

import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Link } from '@/i18n/navigation'
import { useTranslations } from 'next-intl'

export default function Custom404() {
  const t = useTranslations()

  return (
    <div className='min-h-screen'>
      <div className='absolute inset-0'>
        <div className='absolute inset-0 opacity-20'>
          <div className='wave wave1'></div>
          <div className='wave wave2'></div>
          <div className='wave wave3'></div>
        </div>
      </div>

      {/* Main content */}
      <div className='relative z-10 flex flex-col items-center justify-center min-h-screen px-4 text-center'>
        <div className='max-w-2xl mx-auto'>
          <div className='mb-8'>
            <h1>{t('page_not_found')}</h1>
            <h2>{t('page_not_found_message')}</h2>
          </div>

          {/* Action buttons */}
          <div className='flex flex-col sm:flex-row gap-4 justify-center items-center'>
            <Button asChild variant='default' size='lg' className='px-4'>
              <Link href='/'>
                <ArrowLeft className='mr-2' size={20} />
                {t('return_to_home')}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
